export default __webpack_public_path__ + "static/media/user.cad7763a.PNG";